/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportFilter } from './reportFilter';

export interface ReportRequest {
  [key: string]: any | any;

  name?: string | null;
  slug?: string | null;
  textParameters?: { [key: string]: any } | null;
  reportFields?: Array<string> | null;
  reportFilters?: Array<ReportFilter> | null;
}
